import { MouseEvent, useState } from 'react'
import { Modal } from '../../../component/modal'
import { Cover, MediaFile } from '../../../entity'
import { useTranslation } from 'react-i18next'
import { PhotoEditor } from './editor/photo-editor'
import { useDispatch, useSelector } from 'react-redux'
import { PHOTO_EDITOR_ACTIONS } from '../../../action/photos/photos.constants'
import { State } from '../../../state'
import { getWarranty } from '../../../action'
import './edit-media-file-modal.scss'
import {VideoEditor} from "./video-editor/video-editor";

interface EditMediaFileModalProps {
    warrantyId: number

    mediaFile: MediaFile
    onCloseClick: () => void
    onCancelCallback: CallableFunction
    onAcceptCallback: CallableFunction
}

export const EditMediaFileModal = (props: EditMediaFileModalProps) => {
    const dispatch = useDispatch()
    const { t } = useTranslation()

    const [actualCover, setActualCover] = useState<Cover | null>(null)

    const { acceptCover, isToolsEnabled } = useSelector((state: State) => state.editor)

    const onCancelButtonClick = async (event: MouseEvent) => {
        event.preventDefault()

        {
            !isToolsEnabled ? (acceptCover != null ? onDeleteAllCovers() : props.onCancelCallback()) : onRemoverLastCover()
        }
    }

    const onAcceptButtonClick = async (event: MouseEvent) => {
        event.preventDefault()

        {
            !isToolsEnabled ? props.onAcceptCallback() : onAcceptCover()
        }
    }

    const onAcceptCover = async () => {
        if (actualCover != null) {
            dispatch({ type: PHOTO_EDITOR_ACTIONS.ADD_COVER, cover: actualCover, from: 0.001 })
        }

        dispatch({ type: PHOTO_EDITOR_ACTIONS.SELECTED_TOOL, tool: null })
        dispatch({ type: PHOTO_EDITOR_ACTIONS.IS_TOOLS_ENABLED, enabled: false })
        dispatch({ type: PHOTO_EDITOR_ACTIONS.ACCEPT_COVER, acceptCover: false })

        setActualCover(null)

        await getWarranty(props.warrantyId)
    }

    const onRemoverLastCover = () => {
        dispatch({ type: PHOTO_EDITOR_ACTIONS.REMOVE_COVER })
        dispatch({ type: PHOTO_EDITOR_ACTIONS.ACCEPT_COVER, acceptCover: false })
        dispatch({ type: PHOTO_EDITOR_ACTIONS.SELECTED_TOOL, tool: null })
        dispatch({ type: PHOTO_EDITOR_ACTIONS.IS_TOOLS_ENABLED, enabled: false })

        setActualCover(null)
    }

    const onDeleteAllCovers = () => {
        dispatch({ type: PHOTO_EDITOR_ACTIONS.DELETE_ALL_COVER })
        dispatch({ type: PHOTO_EDITOR_ACTIONS.SELECTED_TOOL, tool: null })
        dispatch({ type: PHOTO_EDITOR_ACTIONS.IS_TOOLS_ENABLED, enabled: false })
        dispatch({ type: PHOTO_EDITOR_ACTIONS.ACCEPT_COVER, acceptCover: null })

        setActualCover(null)
    }

    return (
        <Modal
            title={t(props.mediaFile.type === 0 ? 'photo_info_modal_title' : 'video_info_modal_title') + ' ' + props.mediaFile.id}
            onCloseClick={() => {
                dispatch({ type: PHOTO_EDITOR_ACTIONS.ACCEPT_COVER, acceptCover: null })
                props.onCloseClick()
            }}
        >
            <label className="edit-modal-description">{t('edit_photo_modal_description')}</label>

            { props.mediaFile.type === 0 ? (
                <PhotoEditor
                    photo={props.mediaFile}
                    editable={true}
                    onDrawEnd={(cover: Cover) => {
                        setActualCover(cover)
                        //disápatch({ type: PHOTO_EDITOR_ACTIONS.ADD_COVER, cover: cover })
                    }}
                />
            ) : (
                <VideoEditor
                    mediaFile={props.mediaFile}
                    editable={true}
                    onDrawEnd={(cover: Cover) => {
                        setActualCover(cover)
                        //dispatch({ type: PHOTO_EDITOR_ACTIONS.ADD_COVER, cover: cover })
                    }}
                />
            ) }

            <div className={`edit-photo-modal__buttons`}>
                <button className="button" onClick={onCancelButtonClick}>
                    {isToolsEnabled ? t('edit_photo_modal_delete_cover_button') : acceptCover != null ? t('edit_photo_modal_delete_all_cover_button') : t('button_cancel')}
                </button>

                <button className="button" onClick={onAcceptButtonClick}>
                    {isToolsEnabled ? t('edit_photo_modal_place_cover_button') : acceptCover != null ? t(props.mediaFile.type === 0 ? 'edit_photo_modal_accept_photo_button' : 'edit_video_modal_accept_video_button') : t('edit_photo_modal_accept_covering_button')}
                </button>
            </div>
        </Modal>
    )
}
